(() => {
  const routinesEls = document.querySelectorAll('[data-routines]');

  const init = () => {
    if (!window.routinesInit) {
      window.routinesInit = true;

      Array.from(routinesEls).forEach((routinesEl) => {
        const routinesItemEls = routinesEl.querySelectorAll('[data-routines-item]');

        Array.from(routinesItemEls).forEach((routinesItemEl) => {
          routinesItemEl.addEventListener('click', handleItemClick);
        });

        startToggleTimer(routinesEl);
      });

      initSlider();

      const comboCTA = document.querySelector('.routines__button-combo-adder');
      if(comboCTA){
        comboCTA.addEventListener('click', addAllToCart)
      }
    }
  }

  const startToggleTimer = (routinesEl) => {
    let itemIndex = 1;

    setInterval(() => {
      Array.from(routinesEl.querySelectorAll('[data-routines-item]')).forEach((routinesItemEl) => {
        routinesItemEl.classList.remove('active');
      });

      routinesEl.querySelector(`[data-routines-item="${itemIndex}"]`).classList.add('active');

      Array.from(routinesEl.querySelectorAll('[data-routines-image]')).forEach((routinesImageEl) => {
        routinesImageEl.classList.remove('active');
      });

      Array.from(routinesEl.querySelectorAll('[data-routines-image-product]')).forEach((routinesImageEl) => {
        routinesImageEl.classList.remove('active');
      });

      routinesEl.querySelector(`[data-routines-image="${itemIndex}"]`).classList.add('active');
      const currProdImg = routinesEl.querySelector(`[data-routines-image-product="${itemIndex}"]`);
      if (currProdImg) {
        currProdImg.classList.add('active');
      }

      if (routinesEl.querySelector(`[data-routines-image="${itemIndex + 1}"]`)) {
        itemIndex++;
      } else {
        itemIndex = 1;
      }
    }, 10000);
  }

  const handleItemClick = (event) => {
    const routinesItemEl = event.target;
    const routinesEl = routinesItemEl.closest('[data-routines]');
    const itemIndex = routinesItemEl.closest('[data-routines-item]').dataset.routinesItem;

    Array.from(routinesEl.querySelectorAll('[data-routines-image]')).forEach((routinesImageEl) => {
      routinesImageEl.classList.remove('active');
    });

    Array.from(routinesEl.querySelectorAll('[data-routines-image-product]')).forEach((routinesImageEl) => {
      routinesImageEl.classList.remove('active');
    });

    routinesEl.querySelector(`[data-routines-image="${itemIndex}"]`).classList.add('active');
    const currProdImg = routinesEl.querySelector(`[data-routines-image-product="${itemIndex}"]`);
    if (currProdImg) {
      currProdImg.classList.add('active');
    }

    Array.from(routinesEl.querySelectorAll('[data-routines-item]')).forEach((routinesItemEl) => {
      routinesItemEl.classList.remove('active');
    });

    routinesEl.querySelector(`[data-routines-item="${itemIndex}"]`).classList.add('active');
  }

  const initSlider = () => {
    const slider = tns({
      container: '[data-routines-slider]',
      edgePadding: 18,
      gutter: 18,
      nav: false,
      mouseDrag: true,
      fixedWidth: 242,
      swipeAngle: false,
      loop: true,
      responsive: {
        1: {
          disable: false
        },
        741: {
          disable: true
        }
      },
      onInit: (info) => {
        const indexCurrent = info.index;

        info.slideItems[indexCurrent].classList.add('active');
      }
    });

    slider.events.on('indexChanged', handleSliderIndexChanged);
  }

  const handleSliderIndexChanged = (info) => {
    const indexCurrent = info.index;

    Array.from(info.slideItems).forEach((slideItem) => {
      slideItem.classList.remove('active');
    });
    info.slideItems[indexCurrent].classList.add('active');
  }

  const addAllToCart = async (event) => {
    let itemsToAdd = event.target.getAttribute('combo-items').split(';')
    itemsToAdd.pop(); // Last item is empty
    let uniqueItemsToAdd = [...new Set(itemsToAdd)];

    if (!uniqueItemsToAdd) {
      return;
    }

    for (let i = 0; i < uniqueItemsToAdd.length; i++) {
      uniqueItemsToAdd[i] = {
        id: uniqueItemsToAdd[i],
        quantity: 1
      }
    }

    uniqueItemsToAdd = {'items': uniqueItemsToAdd}

    fetch(window.themeVariables.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(uniqueItemsToAdd)
    })
        .then(async response => {
          const responseJson = await response.json();

          if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
            return window.location.href = `${Shopify.routes.root}cart`;
          }
          this.dispatchEvent(new CustomEvent("variant:added", {
            bubbles: true,
            detail: {
              variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
            }
          }));
          fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
            const cartContent = await response2.json();
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent
              }
            }));
            cartContent["sections"] = responseJson["sections"];
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
              }
            }));
          });
          //open the cart if success and not already open
          var miniCart = document.getElementById('mini-cart');
          if (!miniCart.open) {
            miniCart.open = true;
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
  }

  document.addEventListener("DOMContentLoaded", init);
})();